import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

interface TFamilyData extends Omit<TFamily, 'districtId'> {
  students: Omit<TStudent, 'familyAccountId'>[]
}

interface TDistrictInfo extends TDistrict {
  families: TFamilyData[]
}

interface CheckoutInfoPayload {
  checkoutData: TDistrictInfo[]
  fundingSources: Record<number, TFundingSource[]>
}

// GET /ajax/dashboard_info (formerly checkout_info)
export const dashboardInfo = async (options?: { signal?: AbortSignal }) => {
  const response = await new Request().get('/ajax/checkout_info', options)
  return Util.Obj.keysToCamel(response.data.checkout_info) as CheckoutInfoPayload
}
